import { oc } from '@orpc/contract';
import { tradeInCaseSchema, upsertTradeInInputSchema } from '../schemas/trade-in.schemas.js';
/**
 * Creates the case on first use and patches it afterwards, bumping the vehicle's revision. The figures
 * are **scenario figures only**: they produce `supportRate` and `support` beside the ceiling and never
 * enter `total`, `retail` or the dashboard (plan §5.9).
 */
export const upsertTradeInContract = oc
    .route({
    method: 'PUT',
    path: '/vehicles/{vehicleId}/trade-in',
    tags: ['Trade-in'],
    summary: 'Record the trade-in scenario figures',
})
    .input(upsertTradeInInputSchema)
    .output(tradeInCaseSchema);
//# sourceMappingURL=upsert-trade-in.contract.js.map